module.exports = __webpack_public_path__ + "static/farewell_banner-64aa01edfcdabf86ab82d834d86fcb0a.png";